import css from './dropdown.css'

const Column = ({ title, className, items }) => (
    <div className={className}>
        <h2 className={css.menuHeader}>
            <a href={`/${title}`}>{title}</a>
        </h2>
        <ul className={css.dropDownLinks}>
            {items.map(({ label, path }, i) => (
                <li key={i}>
                    <a href={path}>{label}</a>
                </li>
            ))}
        </ul>
    </div>
)

const Dropdown = () => (
    <div className="menuDropDown">
        <div className={css.columns}>
            <Column
                title="categories"
                className={css.menuCategories}
                items={[
                    { label: `GIPHY Studios`, path: `/giphystudios` },
                    { label: `Animals`, path: `/categories/animals` },
                    { label: `Holidays`, path: `/categories/holiday` },
                    { label: `Food & Drink`, path: `/categories/food-drink` },
                    { label: `Memes`, path: `/categories/memes` },
                    { label: `Actions`, path: `/categories/actions` },
                    { label: `Emotions`, path: `/categories/emotions` },
                    { label: `Anime`, path: `/categories/anime` },
                    { label: `Gaming`, path: `/categories/gaming` },
                    { label: `Cartoons`, path: `/categories/cartoons-comics` },
                ]}
            />
            <Column
                title="stickers"
                className={css.smallColumn}
                items={[
                    { label: `Originals`, path: `/originals/stickers/studiosoriginalstickers` },
                    { label: `Trending`, path: `/stickers/trending` },
                    { label: `Reactions`, path: `/stickers/reactions` },
                    { label: `Packs`, path: `/stickers/packs` },
                ]}
            />
            <Column
                title="apps"
                className={css.smallColumn}
                items={[
                    { label: `GIPHY`, path: `/apps/giphy` },
                    { label: `GIPHY World`, path: `/apps/giphyworld` },
                    { label: `GIPHY Cam`, path: `/apps/giphycam` },
                    { label: `GIPHY Capture`, path: `/apps/giphycapture` },
                ]}
            />
            <Column
                title="about"
                className={css.largeColumn}
                items={[
                    { label: `Team`, path: `/team` },
                    { label: `Engineering Blog`, path: `https://engineering.giphy.com/blog/` },
                    { label: `Studios`, path: `/studios` },
                    { label: `Marketers`, path: `/marketers` },
                    { label: `Developers`, path: `https://developers.giphy.com/` },
                    { label: `Labs`, path: `/labs` },
                    { label: `FAQ`, path: `/faq` },
                    { label: `Support`, path: `/support` },
                    { label: `Terms`, path: `/terms` },
                    { label: `Privacy`, path: `/privacy` },
                    { label: `DMCA`, path: `/dmca` },
                    { label: `Guidelines`, path: `/community-guidelines` },
                ]}
            />
        </div>
        <div className={css.footer}>
            <div className={css.copyright}>&copy; {new Date().getFullYear()} GIPHY, Inc.</div>
            <div className={css.tosLinks}>
                <a href="/terms" target="_blank">
                    Terms of Service
                </a>
                <a href="/community-guidelines" target="_blank">
                    Community Guidelines
                </a>
                <a href="/privacy" target="_blank">
                    Privacy Policy
                </a>
                <a href="/dmca" target="_blank">
                    Copyright
                </a>
            </div>
        </div>
    </div>
)

export default Dropdown
